import PropTypes from "prop-types";
import styled from "styled-components";

import Loading from "@/components/core/layout/loading";

const SettingsProgress = styled.p`
    text-align: center;
    color: gray;
`;

/**
 * Loading spinner showing settings save/publish progress (current/total).
 *
 * @param root0 - The component props.
 * @param root0.lightGroupSettingsStatus - The current save/publish status text.
 * @param root0.lightGroupSettingsProgress - The progress fraction (current/total).
 * @returns The rendered settings progress indicator.
 */
const GroupSettingsProgress = ({
    lightGroupSettingsStatus,
    lightGroupSettingsProgress,
}) => (
    <Loading message={lightGroupSettingsStatus?.message ?? ""} type="spinner">
        {lightGroupSettingsProgress && (
            <SettingsProgress>
                {lightGroupSettingsProgress?.current}/
                {lightGroupSettingsProgress?.total}
            </SettingsProgress>
        )}
    </Loading>
);

GroupSettingsProgress.propTypes = {
    lightGroupSettingsStatus: PropTypes.object,
    lightGroupSettingsProgress: PropTypes.object,
};

export default GroupSettingsProgress;
